import { Head } from 'vite-react-ssg'
import { useLocale } from '../i18n/locale'
import { t } from '../i18n/strings'

export interface QA {
  q: string
  a: string
}

export default function Faq({ items }: { items: QA[] }) {
  const locale = useLocale()
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((it) => ({
      '@type': 'Question',
      name: it.q,
      acceptedAnswer: { '@type': 'Answer', text: it.a },
    })),
  }
  return (
    <section className="mt-10">
      <h2 className="text-2xl">{t(locale, 'calc.faqHeading')}</h2>
      <div className="mt-4 divide-y divide-border rounded-lg border border-border bg-surface">
        {items.map((it, i) => (
          <details key={i} className="group p-4">
            <summary className="cursor-pointer list-none font-medium text-text marker:hidden">
              <span className="inline-flex w-full items-center justify-between gap-2">
                {it.q}
                <span className="text-text-subtle transition-transform group-open:rotate-45">+</span>
              </span>
            </summary>
            <p className="mt-2 text-text-muted">{it.a}</p>
          </details>
        ))}
      </div>
      <Head>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Head>
    </section>
  )
}
